angular.module('picmonic-common').directive('countrySelect', [
  'CountryStateConfig',
  function (CountryStateConfig) {
    return {
      restrict: 'E',
      scope: {
        ngModel: '=',
        class: '@',
      },
      link: function (scope, element, attrs) {
        scope.countries = CountryStateConfig.countries;
      },
      template:
        '<select ng-attr-class="{{class}}" ng-model="ngModel" ng-options="country.name as country.name for country in countries | orderBy: [\'-priority\', \'name\']"><option value="">Select</option></select>',
    };
  },
]);
